import React, { useEffect, useRef } from 'react';
import useResponsiblePersons from '@hooks/responsible-persons/responsible-persons';
import { LovDTO } from '@api/ringil-api.v2';
import { MultiSelect } from 'primereact/multiselect';
import { deferStampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  responsiblePersons: LovDTO[];
  onChange: (responsiblePersons: LovDTO[]) => void;
  style?: any;
  showClearButton?: boolean;
  disabled?: boolean;
  placeholder?: string;
  dataTestId?: string;
}

const InputResponsiblePerson: React.FC<ComponentProps> = ({ responsiblePersons, onChange, style, showClearButton = false, disabled = false, placeholder, dataTestId }) => {
  const options = useResponsiblePersons();
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    return deferStampDataTestIdOnDescendantRef(wrapperRef, '.p-multiselect', dataTestId);
  }, [dataTestId, options]);

  return (
    <div ref={wrapperRef}>
      <MultiSelect
        value={responsiblePersons}
        options={options}
        onChange={e => onChange(e.target.value)}
        optionLabel="name"
        dataKey={'id'}
        style={style}
        showClear={showClearButton}
        disabled={disabled}
        placeholder={placeholder}
        filter={true}
        panelClassName={dataTestId}
        itemTemplate={(option: LovDTO) => (
          <div data-testid={dataTestId ? `${dataTestId}-${toTestIdSlug(option.name)}` : undefined}>
            {option.active ? <span>{option.name}</span> : <span style={{ textDecoration: 'line-through', color: 'gray' }}>{option.name}</span>}
          </div>
        )}
      />
    </div>
  );
};

export default InputResponsiblePerson;
